import React from 'react';

import icoClose from 'assets/images/close-btn-black.svg';
import icoSuccessful from 'assets/images/dialogs/ChargeSuccessful.svg';
import S from 'constants/string.const';
import getArray from 'utils/accessors/getArray.util';

import ConfirmationDialog from 'scheduler/components/ConfirmationDialog';
import StylistWithEmail from 'settings/stylists/StylistWithEmail';

import 'styles/settings/pages/pincode-modal-existing-email.scss'; // eslint-disable-line import/first

class PincodeExistingEmailPopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: true,
      confirmationDialog: false,
      successfulDialog: false,
      userId: -1,
      userEmail: '',
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.removedAccess && nextProps.removedAccess) {
      this.setState({ successfulDialog: true });
    }
  }

  // FIXME: check if this duplicate or the following one is the correct
  // noinspection JSUnusedGlobalSymbols
  onSetupPinDuplicate = () => {
    this.props.closePinPopup();
    this.setState({ confirmationDialog: false, showModal: false });
  };

  onSetupPin = () => void this.props.closePopup();

  onRemove = (userId) => {
    this.props.removeAccess(this.props.salonId, userId);
    this.setState({ confirmationDialog: false, showModal: true });
  };

  exit = () => {
    // FIXME: as the main sidebar has been rewritten this selectors no longer exists
    const menuBtn = document.querySelector('.nav-button.closed');
    const mainMenu = document.querySelector('.nav.isClose');

    if (menuBtn) {
      menuBtn.classList.remove('closed');
      menuBtn.classList.add('opened');
    }

    if (mainMenu) {
      mainMenu.classList.remove('isClose');
      mainMenu.classList.add('visible');
      // Guan, issue on this 👆  once menu is opened I can't close it by clicking X icon from nav menu
    }

    this.setState({ showModal: false });
    this.props.closePopup();
    this.props.toggleMenu();
  };

  showRemovePopup = (userId, userEmail) =>
    void this.setState({
      confirmationDialog: true,
      showModal: false,
      userId,
      userEmail,
    });
  cancelRemove = () => void this.setState({ confirmationDialog: false, showModal: true });
  showRemoveAccess = () => void this.setState({ successfulDialog: true, confirmationDialog: false });

  closeSuccessfulDialog = () => {
    this.setState({ successfulDialog: false, confirmationDialog: false, showModal: true });
    this.props.resetRemovedAccess();
  };

  render() {
    const { userEmail, userId, confirmationDialog, successfulDialog, showModal } = this.state;
    const emailsWithLogin = getArray('emailsWithLogin', this.props);

    return (
      <div data-bem="PincodeExistingEmailPopup">
        {showModal && (
          <>
            <div className="overlay-existing-email" />
            <div id="modal-existing-email">
              <span className="close-btn" role="button" tabIndex="0" onClick={this.exit}>
                <img src={icoClose} alt="Exit anyway" />
              </span>
              <div className="scroll-area">
                <h2 className="title">Warning! All users with email access should have a pincode enabled</h2>
                <div className="description">
                  The following users with an email login <strong>do not have a pincode enabled</strong>, which means
                  they <strong>won{S.apos}t be able to access Slick</strong> when logging in via email:
                </div>
                <div className="user-list">
                  <ul>
                    {emailsWithLogin.map(({ id, email }) => (
                      <li data-bem="PincodeExistingEmailPopup__stylist-with-email-container" key={`${id}-${email}`}>
                        <StylistWithEmail
                          id={id}
                          email={email}
                          onSetupPin={this.onSetupPin}
                          onRemove={this.onRemove}
                          showRemovePopup={this.showRemovePopup}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="additional-text">
                  <p> If any of these email addresses should no longer have access, click “remove access”.</p>
                  <p>Or, setup their pincode by selecting a staff member and linking to their email address.</p>
                  <p>If they don{S.apos}t have a column, select “add new user” and link the email address that way.</p>
                </div>
              </div>
              <div className="footer-existing-email">
                <button className="btn btn-violet" onClick={this.exit}>
                  Exit anyway
                </button>
              </div>
            </div>
          </>
        )}
        {confirmationDialog && (
          <ConfirmationDialog
            onRequestClose={() => {}}
            title=""
            leftButtonText="NO, CANCEL"
            onLeft={this.cancelRemove}
            rightButtonText="YES REMOVE ACCESS"
            onRight={() => this.onRemove(userId)}
            displayHeader="header-non"
            onCancel={() => {}}
          >
            <h2 className="dialog-inner-title" style={{ marginTop: '0', paddingLeft: '0' }}>
              Are you sure you want to remove email access?
            </h2>
            <strong className="text-bold">{userEmail}</strong> will no longer be able to access Slick remotely via email
            login
            <br />
          </ConfirmationDialog>
        )}
        {successfulDialog && (
          // clicking OK should return them to the popup modal
          // with the email users who don't have pincode
          // (updated to exclude the one which was just removed)

          <ConfirmationDialog
            onRequestClose={() => {}}
            title=""
            leftButtonText=""
            onLeft={() => {}}
            rightButtonText="OK"
            onRight={this.closeSuccessfulDialog}
            displayHeader="header-non"
            onCancel={() => {}}
          >
            <h2 className="dialog-inner-title" style={{ marginTop: '0', paddingLeft: '0' }}>
              Email login access successfully removed
            </h2>
            <img
              src={icoSuccessful}
              alt="Email login access successfully removed"
              style={{ display: 'block', margin: '0 auto' }}
            />
            <br />
          </ConfirmationDialog>
        )}
      </div>
    );
  }
}

export default PincodeExistingEmailPopup;
